<template>
  <label for="corporation_file" class="o_button">
    <span>CSVインポート</span>
    <input
      type="file"
      style="display:none"
      id="corporation_file"
      ref="fileInput"
      @change="onChange"
      @click="onClick"
    />
    <DetailMessageModalComponent :idDetailMessageModal="idDetailMessageModal" title="インポートエラー" :errMsges="errMsges"/>
  </label>
</template>
<script>
import FlashMessage from '../../common/flash-message.component'
import DetailMessageModalComponent from '../custom-components/DetailMessageModalComponent.vue'
import AppConstants from '../../constants/app.constants'
import ErrorCdMsgConstants from '../../constants/error-cd-msg.constants'
export default {
  components: {
    DetailMessageModalComponent
  },
  props: {
    mappingNo: {
      type: String,
      default: 'ie-item'
    }
  },
  data() {
    return {
      originalFileData: {}, // 元のファイルデータ格納
      errMsges: [],
      isUpload: false, // アップロードを開始したかのフラグ
      idDetailMessageModal: AppConstants.ID_MODAL_ERROR_MESSAGE_IMPORT
    }
  },
  created() {
  },
  filters: {
    replaceMsg(msg) {
      return msg ? msg.replace('<br/>', '') : msg
    }
  },
  methods: {
    csvUpload() {
      this.isUpload = true
      this.$emit('is-loading', true)
      this.$_csvUploadStrt()
    },
    $_csvUploadStrt() {
      let uploadFile = this.originalFileData.file
      let formData = new FormData()
      formData.append('file', uploadFile)
      this.$axios
        .post(`/table/ie/import/${this.mappingNo}`, formData)
        .then(response => {
          // 登録処理完了
          this.isUpload = false
          this.$emit('is-loading', false)
          this.$emit('import')
          document.getElementById('corporation_file').value = ''
          this.$store.commit('setImportMode', false)
          return FlashMessage.getInstance().showSuccessMessage('アップロード完了。')
        })
        .catch(error => {
          this.isUpload = false
          this.$emit('is-loading', false)
          this.$emit('import')
          document.getElementById('corporation_file').value = ''
          if (!navigator.onLine || !error || !error.response || !error.response.data) {
            return
          }
          const errObj = error.response.data
          this.errMsges = []
          const isValidErr = errObj.errCd.match(/VALID_ERR_000[2-3]/)
          for (let key in errObj.errMap) {
            let errors = errObj.errMap[key]
            errors.forEach(errStr => {
              if (isValidErr) {
                this.errMsges.push(errStr + '、項目名：' + key)
              } else {
                this.errMsges.push(errStr)
              }
            })
          }

          if (errObj.errCd === ErrorCdMsgConstants.TOTAL_RECORDS_LIMIT_IN_DB_EXCEEDED_ERR_CD) {
            FlashMessage.getInstance().showErrorMessage(errObj.errMsg)
          } else {
            FlashMessage.getInstance().showErrorMsgWithErrorCode(
              ErrorCdMsgConstants.FUNC_FAILED_CSV_IMPORT_ERR_CD,
              ErrorCdMsgConstants.FUNC_FAILED_CSV_IMPORT_ERR_MSG,
              true
            )
          }
        })
    },
    onClick() {
      this.$emit('on-import')
    },
    onChange(event, key = '', image = {}) {
      // ①ファイル取得
      let fileList = event.target.files
        ? event.target.files
        : event.dataTransfer.files
      // ファイルが無い時は処理を中止
      if (fileList.length === 0) {
        return false
      }
      const file = fileList[0]
      var results = file.name.match(/.csv$/g) || []
      if (results.length === 0) {
        FlashMessage.getInstance().showErrorMessage(`CSVファイルをアップロードしてください。`)
        return false
      }
      this.originalFileData = {
        file: file,
        uploadStatus: 0
      }
      this.csvUpload()
    }
  }
}
</script>
<style lang="scss" scoped>
label.o_button {
  display: block;
  min-width: 180px;
  @include responsive-fs(14);
  line-height: 28px;
  padding: 0 5px;
  margin: 5px;
  max-height: 300px;
  overflow: auto;
}
label.o_button:hover {
  background-color: #67A3C7;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CsvImportButton.vue